import { autoinject } from "aurelia-framework";
import { EventAggregator } from "aurelia-event-aggregator";
import moment from "moment";

import { IDeleteItemBehavior } from "../../../interfaces/form-builder/i-behavior";
import { FormButtonEvent } from "../form-input/form-button/form-button";
import { ToastrService } from "../../../services/toastr-service";
import { NoteDataManager } from "../note-data-manager";
import { FormValidationEnum } from "../../../enums/form-validation-enum";

@autoinject
export class DeleteItemBehaviorHandler {
    private _ea: EventAggregator;
    private _toastrService: ToastrService;

    public constructor(ea: EventAggregator, toastrService: ToastrService) {
        this._ea = ea;
        this._toastrService = toastrService;
    }

    public handle(buttonBehavior: IDeleteItemBehavior, elementName: string, noteDataManager: NoteDataManager) {
        if (buttonBehavior.validations?.length > 0) {
            let deleteEncounterValidation = buttonBehavior.validations.find(
                (validation) => validation.validationType === FormValidationEnum.EncounterDeleteTimeFrameValidation
            );
            if (!!deleteEncounterValidation) {
                let noteModel = noteDataManager.getNoteModel();
                let modifiedData = noteDataManager.getModifiedData();
                let targetValues: IDeleteItemBehaviorValidationTarget[] = [];
                let mergedUniqueKeys = [...new Set([...Object.keys(noteModel), ...Object.keys(modifiedData)])];
                mergedUniqueKeys.forEach((key) => {
                    // TODO: Use list of listgroups to target specific listgroup property name after BE updates behavior.
                    if (
                        key.includes(deleteEncounterValidation.validationTargetName) &&
                        !!noteDataManager.getValue(key)
                    ) {
                        targetValues.push({ name: key, value: noteDataManager.getValue(key) as string });
                    }
                });
                let splitElementName = elementName.split(".");
                if (splitElementName.length > 2) {
                    if (deleteEncounterValidation.excludeFields?.length) {
                        targetValues = targetValues.filter((value) => {
                            let targetNameSplit = value.name?.split(".");
                            return !deleteEncounterValidation.excludeFields.includes(targetNameSplit[0]);
                        });
                    }
                    let startTime = noteDataManager.getValue(
                        `${splitElementName[0]}.${splitElementName[1]}.${deleteEncounterValidation.validationTargetFields[0]}`
                    ) as string;
                    let endTime = noteDataManager.getValue(
                        `${splitElementName[0]}.${splitElementName[1]}.${deleteEncounterValidation.validationTargetFields[1]}`
                    ) as string;
                    const format = "h:mm A";
                    let momentStarTime = moment(startTime, format);
                    let momentEndTime = moment(endTime, format);
                    let assessment: any;
                    if (startTime && endTime) {
                        assessment = targetValues.find(
                            (target) =>
                                moment(target.value as string, format).isSameOrAfter(momentStarTime) &&
                                moment(target.value as string, format).isSameOrBefore(momentEndTime)
                        );
                    } else if (startTime && !endTime) {
                        assessment = targetValues.find((target) =>
                            moment(target.value as string, format).isSameOrAfter(momentStarTime)
                        );
                    }
                    if (!!assessment) {
                        this._toastrService.error({
                            title: "Error - Delete Encounter",
                            message: `${deleteEncounterValidation.validationMessage}`
                        });
                        return;
                    }
                }
            }
        }
        buttonBehavior.itemName = elementName;
        this._ea.publish(FormButtonEvent.ListDeleteItem, buttonBehavior);
    }
}

export interface IDeleteItemBehaviorValidationTarget {
    name: string;
    value: string;
}
